import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { WithAccountId } from '@mews-commander/types';
import { useInvalidatePaymentMethodsTableRecordsQuery } from '../../../queries';

export const useDeletePaymentCard = ({ accountId }: WithAccountId) => {
    const invalidatePaymentMethodsTableQuery = useInvalidatePaymentMethodsTableRecordsQuery();

    return useRepositoryMutation('paymentCard', 'delete', {
        onSuccess: () => {
            showSuccessAlert({ description: lt('CreditCardDeleteAlertSuccessMessage') });
            invalidatePaymentMethodsTableQuery({ customerId: accountId });
        },
    });
};

export const useDisablePaymentCard = ({ accountId }: WithAccountId) => {
    const invalidatePaymentMethodsTableQuery = useInvalidatePaymentMethodsTableRecordsQuery();

    return useRepositoryMutation('paymentCard', 'disable', {
        onSuccess: () => {
            showSuccessAlert({ description: lt('CreditCardDisableSuccessMessage') });
            invalidatePaymentMethodsTableQuery({ customerId: accountId });
        },
    });
};

export const useClearPaymentCard = ({ accountId }: WithAccountId) => {
    const invalidatePaymentMethodsTableQuery = useInvalidatePaymentMethodsTableRecordsQuery();

    return useRepositoryMutation('paymentCard', 'clear', {
        onSuccess: () => {
            showSuccessAlert({ description: lt('CreditCardClearDataSuccessMessage') });
            invalidatePaymentMethodsTableQuery({ customerId: accountId });
        },
    });
};
